import { render, staticRenderFns } from "./WidgetReport.vue?vue&type=template&id=371557a8"
import script from "./WidgetReport.vue?vue&type=script&lang=js"
export * from "./WidgetReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports